export const fullCloseIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#000000"><path d="M20 1.41L14.71 6.7 18 10h-8V2l3.29 3.29L18.59 0zM1.41 20l5.29-5.29L10 18v-8H2l3.29 3.29L0 18.59z"/></svg>`,
  name: 'full-close',
};
